/**
 * @fileoverview Generic dashboard alerts grid component
 */

import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { DashboardAlertCard } from "./DashboardAlertCard";

/**
 * DashboardAlertsGrid - A grid of alert cards
 * @param {Array} alerts - Array of alert configurations
 */
export const DashboardAlertsGrid = ({ alerts = [] }) => {
    if (!alerts || alerts.length === 0) return null;

    return (
        <Grid container spacing={3}>
            {alerts.map((alert, index) => (
                <Grid item xs={12} md={6} key={alert.key || index}>
                    <DashboardAlertCard
                        title={alert.title}
                        items={alert.items}
                        severity={alert.severity}
                        emptyMessage={alert.emptyMessage}
                        onItemClick={alert.onItemClick}
                        maxItems={alert.maxItems}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

DashboardAlertsGrid.propTypes = {
    alerts: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        title: PropTypes.string.isRequired,
        items: PropTypes.array,
        severity: PropTypes.oneOf(['warning', 'error', 'info']),
        emptyMessage: PropTypes.string,
        onItemClick: PropTypes.func,
        maxItems: PropTypes.number
    }))
};
